export class ProduktCombination {
    productName: any = "";
    productCombinationNeedSolutions: any[] =[];
}